(function () {
  'use strict';

  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  function firstLetterFromText(text) {
    if (!text) return null;
    var t = text.replace(/^[^\p{L}0-9]+/u, '');
    if (!t) return null;
    var m = t.match(/\p{L}|\d/u);
    if (!m) return null;
    var l = m[0].toUpperCase();
    if (/[A-Z0-9]/.test(l)) return l;
    var ascii = l.normalize('NFKD').replace(/[^A-Za-z0-9]/g, '');
    return ascii ? ascii[0].toUpperCase() : null;
  }

  function initAlphabetNav(section) {
    var nav = section.querySelector('.alphabet-nav');
    if (!nav) return;
    var targetSelector = nav.dataset.targetSelector || '.gallery .gallery-block';
    function isTruthy(val) {
      if (val === true || val === 'true' || val === 'True' || val === '1') return true;
      if (typeof val === 'string') {
        var v = val.toLowerCase();
        return v === 'true' || v === '1' || v === 'on';
      }
      return false;
    }
    var backToTopEnabled = isTruthy(nav.dataset.backToTop);
    // Try to find target items within the section first; fall back to global selector or heading-like elements
    var items = section.querySelectorAll(targetSelector);
    if (!items || items.length === 0) items = document.querySelectorAll(targetSelector);
    if (!items || items.length === 0) items = section.querySelectorAll('h2,h3,h4,h1,li,dt');
    var firstByLetter = {}; 
    function detectScrollContainer() {
      var se = document.scrollingElement || document.documentElement || document.body;
      if ((se.scrollHeight - se.clientHeight) > 20) return window;
      var possible = document.querySelectorAll('body *');
      for (var i = 0; i < possible.length; i++) {
        var el = possible[i];
        var style = window.getComputedStyle(el);
        if ((style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) return el;
      }
      return window;
    }
    var scrollContainer = detectScrollContainer();
    var headerEl = (function () {
      return document.querySelector('.header') || document.querySelector('store-header') || document.querySelector('header');
    })();

    function getHeaderHeight() {
      try {
        if (!headerEl) return 0;
        var cs = window.getComputedStyle(headerEl);
        var cssMenu = cs.getPropertyValue('--menu-height');
        if (cssMenu) {
          var m = parseInt(cssMenu, 10);
          if (!isNaN(m) && m > 0) return m;
        }
        return Math.round(headerEl.getBoundingClientRect().height) || 0;
      } catch (e) { return 0; }
    }

    function headerIsOverlaying() {
      try {
        if (!headerEl) return false;
        var pos = (window.getComputedStyle && window.getComputedStyle(headerEl).position) || '';
        if (pos === 'fixed' || pos === 'sticky') return true;
        if (headerEl.classList && (headerEl.classList.contains('is-sticky') || headerEl.classList.contains('fixed'))) return true;
        return false;
      } catch (e) { return false; }
    }

    var headerHeight = getHeaderHeight();
    var headerHeightLastChanged = Date.now();

    var navInitialTop = (function () {
      try {
        var navEl = section.querySelector('.alphabet-nav');
        if (!navEl) return 0;
        var rectTop = navEl.getBoundingClientRect().top;
        return rectTop + (scrollContainer === window ? window.pageYOffset : scrollContainer.scrollTop || 0);
      } catch (e) { return 0; }
    })();

    function refreshNavInitialTop() {
      try {
        var navEl = section.querySelector('.alphabet-nav');
        if (!navEl) return;
        navInitialTop = navEl.getBoundingClientRect().top + (scrollContainer === window ? window.pageYOffset : scrollContainer.scrollTop || 0);
      } catch (e) {  }
    }

    if (headerEl) {
      if ('ResizeObserver' in window) {
        try {
          var ro = new ResizeObserver(function () {
            headerHeight = getHeaderHeight();
            headerHeightLastChanged = Date.now();
            refreshNavInitialTop();
            checkSticky();
            onScroll();
          });
          ro.observe(headerEl);
        } catch (e) {  }
      }
      window.addEventListener('resize', function () { headerHeight = getHeaderHeight(); refreshNavInitialTop(); checkSticky(); onScroll(); }, { passive: true });
      window.addEventListener('resize', function () { headerHeightLastChanged = Date.now(); }, { passive: true });
    }

    items.forEach(function (item) {
      var overlay = item.querySelector('.gallery-block__image-text');
      var h3 = overlay && overlay.querySelector('h3');
      var otherHeading = overlay && overlay.querySelector('h1,h2,h4,h5,h6');

      var titleEl = item.querySelector('h3, h2, h1, .rte, .text-overlay__block');
      var text = '';
      if (titleEl && titleEl.textContent) text = titleEl.textContent.trim();
      if (!text && otherHeading && otherHeading.textContent) text = otherHeading.textContent.trim();
      if (!text) {
        text = Array.prototype.slice.call(item.querySelectorAll('*')).map(function (n) { return (n.textContent || '').trim(); }).filter(Boolean).join(' ').trim();
      }
      var letter = firstLetterFromText(text);
      if (letter && !firstByLetter[letter]) firstByLetter[letter] = item;
    });

    var links = section.querySelectorAll('.alpha-link');
    function clearAllActiveStates() {
      try {
        // Clear .active and data-active from any alpha link or its descendants within this nav instance to avoid duplicates
        var all = (section && section.querySelectorAll) ? section.querySelectorAll('.alpha-link, .alpha-link *') : document.querySelectorAll('.alpha-link, .alpha-link *');
        all.forEach(function (el) {
          try {
            if (el.classList && el.classList.contains('active')) el.classList.remove('active');
            if (el.getAttribute && el.getAttribute('data-active')) el.removeAttribute('data-active');
          } catch (e) { /* ignore per element */ }
        });
      } catch (e) { /* ignore */ }
    }

    function setActiveLetter(letter, token) {
      try {
    // If a token is provided and it does not match current nav token, it's stale — ignore
    if (token && nav.dataset.activationToken && nav.dataset.activationToken !== token) { return; }
        // If no token is provided, create one for this programmatic activation
        if (!token) {
          activationCounter += 1;
          token = 'auto-' + activationCounter;
          try { nav.dataset.activationToken = token; } catch (e) { /* ignore */ }
        }

        // aggressively clear any prior active states first
        clearAllActiveStates();
      } catch (e) { /* ignore */ }

      // Only apply active state to links within this nav instance
      links.forEach(function (ln) {
        if (letter && ln.dataset.letter === letter) {
          ln.classList.add('active');
          ln.setAttribute('data-active', 'true');
        } else {
          ln.classList.remove('active');
          ln.removeAttribute('data-active');
        }
      });
      try { if (nav && letter) nav.setAttribute('data-active-letter', letter); else if (nav) nav.removeAttribute('data-active-letter'); } catch (e) { /* ignore */ }
      try {
        var cur = section.querySelector('.alpha-link[data-active="true"]');
      } catch (e) { /* ignore */ }

      // If the alpha list is overflowed (mobile or narrow desktop), bring the active link into view
      try {
        var activeEl = Array.prototype.slice.call(links).find(function (l) { return letter && l.dataset.letter === letter; });
        var alphaListEl = section.querySelector('.alpha-list');
        if (activeEl && alphaListEl && alphaListEl.scrollWidth > alphaListEl.clientWidth) {
          try { activeEl.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) { activeEl.scrollIntoView(); }
        }
      } catch (e) { /* ignore */ }
    }
    links.forEach(function (link) {
      var letter = link.dataset.letter;
      if (letter) link.setAttribute('href', '#alpha-' + letter);
      if (firstByLetter[letter]) {
        link.classList.remove('disabled');
        link.removeAttribute('aria-disabled');
        var anchorId = 'alpha-' + letter;
        if (!document.getElementById(anchorId)) {
          if (!firstByLetter[letter].id) {
            // give the target a predictable anchor ID
            firstByLetter[letter].id = anchorId;
          } else {
            // insert a hidden anchor element so scrolling to ID works reliably
            var anchor = document.createElement('a');
            anchor.id = anchorId;
            anchor.setAttribute('aria-hidden', 'true');
            anchor.setAttribute('href', '#' + anchorId);
            anchor.style.cssText = 'display:block;height:0;visibility:hidden;overflow:hidden;padding:0;margin:0;border:0;line-height:0;';
            anchor.setAttribute('tabindex', '-1');
            firstByLetter[letter].insertBefore(anchor, firstByLetter[letter].firstChild);
          }
        }
        link.addEventListener('click', function (ev) {
          ev.preventDefault();
          // Ignore clicks while programmatic scroll/enforcement is in progress
          if (Date.now() < (scrollLockUntil || 0)) return;
          // Ignore super-fast repeated clicks
          if (Date.now() < (clickIgnoreUntil || 0)) return;
          // Briefly lock to prevent overlapping activations from very fast clicks
          clickIgnoreUntil = Date.now() + 300;

          if (clickRaf) { cancelAnimationFrame(clickRaf); clickRaf = null; }

          // create a unique token for this click so older async loops can't override it
          activationCounter += 1;
          var myToken = 'click-' + activationCounter;
          try { nav.dataset.activationToken = myToken; } catch (e) { /* ignore */ }

          var anchor = document.getElementById('alpha-' + letter);
          try { nav.dataset.lastClickToken = myToken; nav.dataset.lastClickAt = Date.now(); console.debug('[alphabet-nav] lastClickAt set', nav.dataset.lastClickAt); } catch (e) { /* ignore */ }
          setActiveLetter(letter, myToken);
          if (!anchor) return;

          // mark that a programmatic scroll is in progress to prevent other clicks
          scrollLockUntil = Date.now() + 2200;
          try { nav.setAttribute('data-scrolling', 'true'); } catch (e) { /* ignore */ }

          try { headerHeight = getHeaderHeight(); } catch (e) { headerHeight = headerHeight || 0; }
          headerHeightLastChanged = Date.now();
          try { refreshNavInitialTop(); } catch (e) {  }
              try {
                var ln = link; 
                var cs = window.getComputedStyle(ln);
                var bg = cs.getPropertyValue('background-color');
                var fg = cs.getPropertyValue('color');
                ln.style.setProperty('background-color', bg, 'important');
                ln.style.setProperty('color', fg, 'important');
              } catch (e) { }

          if (clickScrollTimer) clearTimeout(clickScrollTimer);
              try { ln.style.removeProperty('background-color'); ln.style.removeProperty('color'); } catch (e) { /* ignore */ }
          desiredActive = letter;
          desiredActiveToken = myToken;
          try { nav.dataset.programmaticActiveLetter = letter; } catch (e) { /* ignore */ }
          // keep a click-timestamp to prevent spurious overrides from later onScroll events
          try { nav.dataset.lastClickAt = Date.now(); } catch (e) { /* ignore */ }
          suppressActiveUntil = Date.now() + 3000;
            forceActiveUntil = Date.now() + 4200;
          if (clickActiveTimer) clearTimeout(clickActiveTimer);
          clickActiveTimer = setTimeout(function () { lastClickedLetter = null; clickActiveTimer = null; desiredActiveToken = null; scrollLockUntil = 0; try { nav.removeAttribute('data-scrolling'); } catch (e) {} try { nav.removeAttribute('data-programmatic-active-letter'); } catch (e) {} try { nav.removeAttribute('data-last-click-at'); nav.removeAttribute('data-last-click-token'); } catch (e) {} onScroll(); }, 3000);

          clickScrollTimer = setTimeout(function () {
            requestAnimationFrame(function () {
              var anchorTop = anchor.getBoundingClientRect().top + (scrollContainer === window ? window.pageYOffset : scrollContainer.scrollTop);
              var navEl = section.querySelector('.alphabet-nav');
              var actualTopOffset = Math.max(parseInt(navEl && navEl.dataset.topOffset || 0, 10) || 0, headerIsOverlaying() ? headerHeight : 0);
              var navFixedHeight = (navEl && (navEl.classList.contains('fixed') || navEl.classList.contains('is-sticky'))) ? navEl.offsetHeight : 0;
              var finalTop = Math.max(0, anchorTop - actualTopOffset - navFixedHeight - 8);
              if (scrollContainer === window) window.scrollTo({ top: finalTop, behavior: 'smooth' });
              else scrollContainer.scrollTo({ top: finalTop, behavior: 'smooth' });
              try { history.replaceState && history.replaceState(null, '', '#alpha-' + letter); } catch (e) { /* ignore */ }
              setTimeout(function () { anchor.setAttribute('tabindex', '-1'); anchor.focus(); }, 600);
              setTimeout(function () {
                try {
                  if (nav.dataset.activationToken === myToken) setActiveLetter(letter, myToken);
                } catch (e) { /* ignore */ }
              }, 700);

              // After the scroll completes, verify the anchor is positioned below the sticky/fixed nav and correct if needed
              setTimeout(function () {
                try {
                  if (nav.dataset.activationToken !== myToken) return;
                  var navElNow = section.querySelector('.alphabet-nav');
                  var actualTopOffsetNow = Math.max(parseInt(navElNow && navElNow.dataset.topOffset || 0, 10) || 0, headerIsOverlaying() ? headerHeight : 0);
                  var navFixedHeightNow = (navElNow && (navElNow.classList.contains('fixed') || navElNow.classList.contains('is-sticky'))) ? navElNow.offsetHeight : 0;
                  var rectNow = anchor.getBoundingClientRect();
                  var desiredViewportTop = actualTopOffsetNow + navFixedHeightNow + 8;
                  // If anchor isn't aligned to sit just below the nav, perform a corrective (instant) scroll
                  if (Math.abs(rectNow.top - desiredViewportTop) > 2) {
                    var anchorTopNow = rectNow.top + (scrollContainer === window ? window.pageYOffset : scrollContainer.scrollTop || 0);
                    var finalTop2 = Math.max(0, anchorTopNow - actualTopOffsetNow - navFixedHeightNow - 8);
                    if (scrollContainer === window) window.scrollTo({ top: finalTop2, behavior: 'auto' });
                    else scrollContainer.scrollTo({ top: finalTop2, behavior: 'auto' });
                    try { anchor.setAttribute('tabindex', '-1'); anchor.focus(); } catch (e) { /* ignore */ }
                  }
                } catch (e) { /* ignore */ }
              }, 900);

              try {
                if (clickRaf) cancelAnimationFrame(clickRaf);
                var enforceStart = Date.now();
                var enforceMax = 2200;
                function enforcementLoop() {
                  var sinceHeaderChange = Date.now() - (headerHeightLastChanged || 0);
                  if (sinceHeaderChange < 120) {
                    if (clickRaf) cancelAnimationFrame(clickRaf);
                    clickRaf = requestAnimationFrame(enforcementLoop);
                    return;
                  }
                  var viewTopNow = getScrollY();
                  var navElNow = section.querySelector('.alphabet-nav');
                  var actualTopOffsetNow = Math.max(topOffset || 0, headerIsOverlaying() ? headerHeight : 0);
                  var navFixedHeightNow = (navElNow && (navElNow.classList.contains('fixed') || navElNow.classList.contains('is-sticky'))) ? navElNow.offsetHeight : 0;
                  var highlightTopNow = viewTopNow + actualTopOffsetNow + navFixedHeightNow + 8;
                  var anchorEntriesNow = LETTERS.map(function (L) { return document.getElementById('alpha-' + L); }).filter(Boolean);
                  var bestNow = null; var bestNowAbs = Infinity; var posNow = [];
                  for (var z = 0; z < anchorEntriesNow.length; z++) {
                    var e = anchorEntriesNow[z];
                    var L = e.id.replace('alpha-','');
                    var targetElNow = (firstByLetter && firstByLetter[L]) ? firstByLetter[L] : null;
                    var rectNow = targetElNow ? targetElNow.getBoundingClientRect() : e.getBoundingClientRect();
                    var centerNow = rectNow.top + (rectNow.height || 0) / 2;
                    var diffNow = centerNow - highlightTopNow;
                    var absDiffNow = Math.abs(diffNow);
                    posNow.push({ letter: L, center: Math.round(centerNow), rectTop: Math.round(rectNow.top) });
                    if (absDiffNow < bestNowAbs) { bestNowAbs = absDiffNow; bestNow = L; }
                  }
                  var currentNow = bestNow || null;
                  if (currentNow === letter) {
                    if (nav.dataset.activationToken === myToken) setActiveLetter(letter, myToken);
                    try {
                      var currentActive = section.querySelector('.alpha-link[data-active="true"]');
                    } catch (e) { /* ignore */ }
                    lastClickedLetter = letter;
                    forceActiveUntil = Date.now() + 1500;
                    if (clickActiveTimer) clearTimeout(clickActiveTimer);
                    clickActiveTimer = setTimeout(function () { lastClickedLetter = null; clickActiveTimer = null; scrollLockUntil = 0; try { nav.removeAttribute('data-scrolling'); } catch (e) {} try { nav.removeAttribute('data-programmatic-active-letter'); } catch (e) {} try { nav.removeAttribute('data-last-click-at'); nav.removeAttribute('data-last-click-token'); } catch (e) {} onScroll(); }, 1500);
                    if (clickRaf) { cancelAnimationFrame(clickRaf); clickRaf = null; }
                    setTimeout(function () {
                      try {
                        var cur = section.querySelector('.alpha-link[data-active="true"]');
                        if (!cur || cur.dataset.letter !== letter) {
                          if (nav.dataset.activationToken === myToken) setActiveLetter(letter, myToken);
                          try {
                            var forceEl = section.querySelector('.alpha-link[data-active="true"]');
                            if (forceEl) {
                              var cs2 = window.getComputedStyle(forceEl);
                              var bg2 = cs2.getPropertyValue('background-color');
                              var fg2 = cs2.getPropertyValue('color');
                              forceEl.style.setProperty('background-color', bg2, 'important');
                              forceEl.style.setProperty('color', fg2, 'important');
                            }
                          } catch (e) {  }
                        }
                      } catch (e) {  }
                    }, 900);
                    return;
                  }
                  if (Date.now() - enforceStart > enforceMax) {
                    if (nav.dataset.activationToken === myToken) setActiveLetter(letter, myToken);
                    lastClickedLetter = letter;
                    forceActiveUntil = Date.now() + 1500;
                    if (clickActiveTimer) clearTimeout(clickActiveTimer);
                    clickActiveTimer = setTimeout(function () { lastClickedLetter = null; clickActiveTimer = null; scrollLockUntil = 0; try { nav.removeAttribute('data-scrolling'); } catch (e) {} try { nav.removeAttribute('data-programmatic-active-letter'); } catch (e) {} try { nav.removeAttribute('data-last-click-at'); nav.removeAttribute('data-last-click-token'); } catch (e) {} onScroll(); }, 1500);
                    if (clickRaf) { cancelAnimationFrame(clickRaf); clickRaf = null; }
                    return;
                  }
                  clickRaf = requestAnimationFrame(enforcementLoop);
                }
                clickRaf = requestAnimationFrame(enforcementLoop);
              } catch (e) {  }
            });
          }, 80);
        });
      } else {
        link.classList.add('disabled');
        link.setAttribute('aria-disabled', 'true');
      }
    });

    var positionMode = (section.querySelector('.alphabet-nav') && section.querySelector('.alphabet-nav').dataset.positionMode) || 'sticky';
    var topOffset = parseInt((section.querySelector('.alphabet-nav') && section.querySelector('.alphabet-nav').dataset.topOffset) || 0, 10) || 0;
    var anchorEntries = LETTERS.map(function (L) { return document.getElementById('alpha-' + L); }).filter(Boolean);
    function onScroll() {
      var current = null;
      // If a programmatic active letter is set (from a click) and we're within the force/suppress window, preserve it and skip recalculation
      try {
        var prog = nav && nav.dataset && nav.dataset.programmaticActiveLetter;
        var lastClickAt = parseInt((nav && nav.dataset && nav.dataset.lastClickAt) || 0, 10) || 0;
        var clickGrace = 4500; // ms - preserve programmatic active for this many ms after click
        if (prog && (Date.now() < (Math.max(forceActiveUntil || 0, suppressActiveUntil || 0)) || (lastClickAt && (Date.now() - lastClickAt) < clickGrace))) {
          try { setActiveLetter(prog, nav && nav.dataset && nav.dataset.activationToken); } catch (e) { /* ignore */ }
          return;
        }
      } catch (e) { /* ignore */ }
      // Ensure we start fresh so only one letter will end up active
      try { clearAllActiveStates(); } catch (e) { /* ignore */ }

      var viewTop = getScrollY();
      var navEl = section.querySelector('.alphabet-nav');
      var actualTopOffset = Math.max(topOffset || 0, headerIsOverlaying() ? headerHeight : 0);
      var navFixedHeight = (navEl && (navEl.classList.contains('fixed') || navEl.classList.contains('is-sticky'))) ? navEl.offsetHeight : 0;
      var highlightTop = viewTop + actualTopOffset + navFixedHeight + 8;
      anchorEntries = LETTERS.map(function (L) { return document.getElementById('alpha-' + L); }).filter(Boolean);
      if (desiredActive && Date.now() < (forceActiveUntil || suppressActiveUntil)) {
        setActiveLetter(desiredActive, desiredActiveToken);
        return;
      }

      try {
        var anchorPositionsLog = anchorEntries.map(function (e) { return { letter: e.id.replace('alpha-',''), top: Math.round(e.getBoundingClientRect().top) }; });
      } catch (e) { /* ignore */ }

      // Compare anchor positions in viewport coordinates so calculations remain stable with sticky/fixed headers
      var highlightViewport = actualTopOffset + navFixedHeight + 8;
      // choose the anchor whose TARGET element center is closest to the highlight line (falls back to anchor if no target)
      var best = null; var bestAbs = Infinity; var positions = [];
      for (var i = 0; i < anchorEntries.length; i++) {
        var el = anchorEntries[i];
        var L = el.id.replace('alpha-','');
        var targetEl = (firstByLetter && firstByLetter[L]) ? firstByLetter[L] : null;
        var rect = targetEl ? targetEl.getBoundingClientRect() : el.getBoundingClientRect();
        var center = rect.top + (rect.height || 0) / 2;
        var diff = center - highlightViewport;
        var absDiff = Math.abs(diff);
        positions.push({ letter: L, center: Math.round(center), rectTop: Math.round(rect.top) });
        if (absDiff < bestAbs) { bestAbs = absDiff; best = L; }
      }
      current = best || null;
      try { } catch (e) { /* ignore */ }
      if (desiredActive && current === desiredActive) {
        desiredActive = null;
        desiredActiveToken = null;
        suppressActiveUntil = 0;
        forceActiveUntil = 0;
        try { nav.removeAttribute('data-programmatic-active-letter'); } catch (e) { /* ignore */ }
        try { nav.removeAttribute('data-last-click-at'); nav.removeAttribute('data-last-click-token'); } catch (e) { /* ignore */ }
      }
      links.forEach(function (link) { if (link.dataset.letter === current) link.classList.add('active'); else link.classList.remove('active'); });
      links.forEach(function (link) { if (link.dataset.letter === current) link.setAttribute('data-active', 'true'); else link.removeAttribute('data-active'); });
      try { } catch (e) { /* ignore */ }
    }

    window.addEventListener('hashchange', function () {
      var m = (location.hash || '').match(/^#alpha-([A-Za-z0-9])/);
      if (m) { setActiveLetter(m[1].toUpperCase()); }
    }, { passive: true });

    var clickScrollTimer = null;
    var clickActiveTimer = null;
    var clickRaf = null;
    var lastClickedLetter = null;
    var desiredActive = null;
    var desiredActiveToken = null;
    var activationCounter = 0;
    var suppressActiveUntil = 0;
    var forceActiveUntil = 0;
    var clickIgnoreUntil = 0; // timestamp to ignore super-fast repeated clicks
    var scrollLockUntil = 0; // timestamp to ignore clicks during programmatic scrolling
    var scrollTimer = null; 
    function getScrollY() {
      if (scrollContainer === window) return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      return scrollContainer.scrollTop || 0;
    }
    function onContainerScroll() {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(onScroll, 40);
      toggleBackToTop();
      checkSticky();
      toggleCompact();
    }
    if (scrollContainer === window) {
      window.addEventListener('scroll', onContainerScroll, { passive: true });
      document.addEventListener('scroll', onContainerScroll, { passive: true });
    } else {
      scrollContainer.addEventListener('scroll', onContainerScroll, { passive: true });
    }

    var spacer = null;
    function checkSticky() {
      var navEl = section.querySelector('.alphabet-nav');
      if (!navEl) return;
      var rect = navEl.getBoundingClientRect();
      var threshold = topOffset || 8;

      // If we're at the top of the page, keep the nav static (no sticky/fixed)
      try {
        var scYTop = getScrollY();
        var topStaticThreshold = Math.max(0, topOffset || 0) + 4;
        if (scYTop <= topStaticThreshold) {
          navEl.classList.remove('is-sticky');
          navEl.classList.remove('fixed');
          try { navEl.style.top = ''; } catch (e) { /* ignore */ }
          if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
          return;
        }
      } catch (e) { /* ignore */ }

      var isMobile = (window.innerWidth || document.documentElement.clientWidth) <= 768;
      if (isMobile) {
        var mobileAllowed = (positionMode === 'fixed' || positionMode === 'fixed-always' || positionMode === 'sticky' || (nav && nav.dataset && (nav.dataset.mobileSticky === 'true' || nav.dataset.mobileSticky === '1')));
        if (mobileAllowed) {
          var actualTop = Math.max(topOffset || 0, headerIsOverlaying() ? headerHeight : 0);
          // use is-sticky to indicate the nav should be visually fixed at top on mobile
          navEl.classList.remove('fixed');
          navEl.classList.add('is-sticky');
          try { navEl.style.top = '100' + 'px'; } catch (e) { navEl.style.top = ''; }
          if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
          return;
        }

        // otherwise keep nav static on mobile
        navEl.classList.remove('fixed');
        navEl.classList.remove('is-sticky');
        try { navEl.style.top = ''; } catch (e) { /* ignore */ }
        if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
        return;
      }

      if (positionMode === 'sticky') {
          var actualTop = Math.max(topOffset || 0, headerIsOverlaying() ? headerHeight : 0);
          if (rect.top <= threshold) { navEl.classList.add('is-sticky'); navEl.style.top = actualTop + 'px'; }
          else { navEl.classList.remove('is-sticky'); navEl.style.top = ''; }
          navEl.classList.remove('fixed');
        if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
      } else if (positionMode === 'fixed' || positionMode === 'fixed-always') {
        var scY = getScrollY();
        var shouldFix = (positionMode === 'fixed-always') || (scY >= (navInitialTop - threshold));
        if (shouldFix) {
            if (!navEl.classList.contains('fixed')) {
            spacer = document.createElement('div');
            spacer.style.height = navEl.offsetHeight + 'px';
            spacer.style.width = '100%';
            navEl.parentNode.insertBefore(spacer, navEl);
            navEl.classList.add('fixed');
            var actualTop = Math.max(topOffset || 0, headerIsOverlaying() ? headerHeight : 0);
            navEl.style.top = actualTop + 'px';
            refreshNavInitialTop();
          }
        } else {
          if (navEl.classList.contains('fixed')) {
            navEl.classList.remove('fixed');
            navEl.style.top = '';
            if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
              refreshNavInitialTop();
          }
        }
      } else {
        navEl.classList.remove('is-sticky');
        navEl.classList.remove('fixed');
        if (spacer) { spacer.parentNode && spacer.parentNode.removeChild(spacer); spacer = null; }
      }
    }

    var backBtn = section.querySelector('.back-to-top');
    // If the markup doesn't include a Back-to-Top button but the nav requests it, create one
    if (backToTopEnabled && !backBtn) {
      try {
        var navEl = section.querySelector('.alphabet-nav') || section;
        backBtn = document.createElement('button');
        backBtn.className = 'back-to-top';
        backBtn.setAttribute('aria-label', 'Back to top');
        backBtn.setAttribute('hidden', '');
        backBtn.innerHTML = '&#8679;';
        navEl.appendChild(backBtn);
      } catch (e) { /* ignore */ }
    }
    function toggleBackToTop() {
      if (!backBtn) return;
      if (!backToTopEnabled) { backBtn.setAttribute('hidden', ''); return; }
      var threshold = window.innerWidth <= 640 ? 120 : 240;
      if (getScrollY() > threshold) backBtn.removeAttribute('hidden'); else backBtn.setAttribute('hidden', '');
    }

    function toggleCompact() {
      var navEl = section.querySelector('.alphabet-nav');
      if (!navEl) return;
      var isMobile = (window.innerWidth || document.documentElement.clientWidth) <= 768;
      if (!isMobile) { navEl.classList.remove('compact'); return; }
      if (getScrollY() > 120) navEl.classList.add('compact'); else navEl.classList.remove('compact');
    }
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (scrollContainer === window) window.scrollTo({ top: 0, behavior: 'smooth' });
        else scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        (function removeFixedImmediate() {
          var navEl = section.querySelector('.alphabet-nav');
          if (!navEl) return;
          if (navEl.classList.contains('fixed')) {
            navEl.classList.remove('fixed');
            navEl.style.top = '';
            var sp = navEl.previousElementSibling;
            if (sp && sp.style && sp.style.height && parseFloat(sp.style.height) > 0) {
              sp.parentNode && sp.parentNode.removeChild(sp);
            }
          }
        })();
      });
      toggleBackToTop();
      toggleCompact();
      setTimeout(toggleBackToTop, 250);
      window.addEventListener('resize', function () { toggleCompact(); checkSticky(); }, { passive: true });
    }

    onScroll();
    checkSticky();
    toggleCompact();
    setTimeout(function () { headerHeight = getHeaderHeight(); refreshNavInitialTop(); checkSticky(); onScroll(); }, 400);
  }

  function initAll() {
    var sections = document.querySelectorAll('.section--alphabet-nav');
    sections.forEach(function (s) { initAlphabetNav(s); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

})();
